import { Distribution, Distributions } from "@custom-types/graphs"

export const MIN_LAG_VALUE = 1
export const MAX_LAG_VALUE = 999

/**
 * Discrete distributions whose support is unbounded on the right, mapped to where that
 * support starts relative to `loc`.
 *
 * Geometric and Logseries start at `loc + 1`; Poisson starts at `loc`. That offset is the
 * only difference between them — every `ubound` rule below is otherwise identical.
 *
 * These are the distributions that need `ubound` at all: without it there is nothing to
 * enumerate, so a node has no possible values and its children have no rows. Binomial is
 * bounded by `n` and Categorical by its columns, so neither belongs here.
 */
export const UNBOUNDED_SUPPORT_FLOOR_OFFSET: Partial<Record<Distributions, number>> = {
  [Distribution.Geometric]: 1,
  [Distribution.Logseries]: 1,
  [Distribution.Poisson]: 0,
}

/**
 * A node with unbounded support may declare at most this many possible values, which
 * keeps a child's row count from exploding.
 *
 * Measured from the support floor (`loc + offset`), so the cap is the same 20 values for
 * all three distributions regardless of where their support starts:
 * `ubound <= loc + offset + MAX_POSSIBLE_VALUES - 1`.
 */
export const MAX_POSSIBLE_VALUES = 20
